import { render, staticRenderFns } from "./RepxListSideMenu.vue?vue&type=template&id=48c44bcd&scoped=true"
import script from "./RepxListSideMenu.vue?vue&type=script&lang=js"
export * from "./RepxListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./RepxListSideMenu.vue?vue&type=style&index=0&id=48c44bcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c44bcd",
  null
  
)

export default component.exports